import type { FC } from 'react';
import { useTranslation } from 'react-i18next';

import { ReportIcon } from 'assets/svg';
import { MenuIconButton } from 'features/menu/components';

interface VrsCallCommentsMenuButtonProps {
  isChecked: boolean;
  isDisabled: boolean;
  onClickHandler: () => void;
}

export const VrsCallCommentsMenuButton: FC<VrsCallCommentsMenuButtonProps> = ({
  isChecked,
  isDisabled,
  onClickHandler,
}) => {
  const { t } = useTranslation();

  return (
    <MenuIconButton
      title={t('report')}
      icon={<ReportIcon title='report' />}
      isDisabled={isDisabled}
      testId='report-menu-button'
      isCheckIconVisible
      isChecked={isChecked}
      onClickHandler={onClickHandler}
    />
  );
};
